export default __webpack_public_path__ + "static/media/cbn.61e509a9.png";